import React from 'react';

import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { TimesCircleIcon } from '../../../../../icon/regular';
import { TimesCircleIcon as TimesSolid } from '../../../../../icon/solid';
import useStyles from './styles';
import { Mood } from './types';

const DeleteRecordAction = ({ mood }: Mood) => {
  const classes = useStyles();
  const isActive = mood === 'delete';
  return (
    <Grid item className={clsx(classes.container, isActive && 'active')}>
      {
        mood
          ? isActive
            ? <TimesSolid className={clsx(classes.icon, classes.deleteIcon)} />
            : <TimesCircleIcon className={classes.icon} />
          : <TimesCircleIcon className={clsx(classes.icon, classes.deleteIcon)} />
      }
      Delete
    </Grid>
  );
};

export default DeleteRecordAction;
